/* Copyright (c) 2017 Backpack Health LLC */

import { RGBA } from '../../../utilities/types';
import chroma from 'chroma-js';
import { useShareCardForActiveProfile } from '../../hooks/useShareCard';

export class ShareCardColorModel {
  constructor(private color: RGBA) {
  }

  cssColor(forceOpacity?) {
    const color = this.color;
    const opacity = forceOpacity || this.color.a;
    return `rgba(${color.r},${color.g},${color.b},${opacity})`;
  }

  darkAccentColor() {
    const { r, g, b, a } = this.color;
    const color = chroma([r, g, b, a]).darken().rgba();
    return `rgba(${color.join(',')})`;
  }

  highlightColor() {
    const { r, g, b, a } = this.color;
    const color = chroma([r, g, b, a]).brighten().rgba();
    return `rgba(${color.join(',')})`;
  }
}

export const ColorShareCard = (props) => {
  const { shareCard, children } = props;

  const [, scActions] = useShareCardForActiveProfile();

  const scColor: ShareCardColorModel = scActions.getShareCardColor(shareCard);

  return children(scColor);
};
